import { Amplify } from 'aws-amplify';
import { logger } from '../utils/logger';
import { runtimeConfig } from './runtimeConfig';

// Get environment configuration from runtime config
const ENVIRONMENT = runtimeConfig.REACT_APP_ENVIRONMENT;
const API_URL = runtimeConfig.REACT_APP_API_URL;
const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || 'debug';

// Log environment configuration
logger.info('Environment Configuration:', {
  environment: ENVIRONMENT,
  apiUrl: API_URL,
  logLevel: LOG_LEVEL
}, 'CONFIG');

// Log API configuration
logger.info('API Configuration initialized', {
  apiUrl: API_URL,
  environment: ENVIRONMENT,
  logLevel: LOG_LEVEL
}, 'API');

// Console log for debugging
console.log('Admin Portal - API URL being used:', API_URL);
console.log('Admin Portal - Environment:', ENVIRONMENT);

// Configure Amplify API
Amplify.configure({
  // Configure Auth
  Auth: {
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  },
  // Configure API
  API: {
    endpoints: [
      {
        name: 'providersApi',
        endpoint: API_URL,
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
        custom_header: async () => {
          return { 
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS'
          };
        }
      }
    ]
  }
});

export const API_CONFIG = {
  ENVIRONMENT,
  API_URL,
  LOG_LEVEL,
  REGION: process.env.REACT_APP_AWS_REGION || 'us-east-1'
}; 